export enum CompanyAdminRoutes {
  companyAdminBase = '/company-admin',
  companyAdminDashboard = '/company-admin/dashboard',
  companyAdminDashboardWithId = '/company-admin/:companyid/dashboard',
  companyAdminAmbassadors = '/company-admin/:companyid/ambassadors',
  companyAdminAmbassadorsArchived = '/company-admin/:companyid/ambassadors/archived',
  companyAdminAmbassadorsAdd = '/company-admin/:companyid/ambassadors/add',
  companyAdminConfiguration = '/company-admin/:companyid/configuration',
  companyAdminShowAmbassador = '/company-admin/:companyid/ambassadors/:employeeid',
  companyAdminEditAmbassador = '/company-admin/:companyid/ambassadors/:employeeid/edit',
  companyAdminEditAmbassadorAvatar = '/company-admin/:companyid/ambassadors/:employeeid/edit/avatar',
  companyAdminEditDescription = '/company-admin/:companyid/description/edit',
  companyAdminAppointments = '/company-admin/appointments',
  companyAdminAppointmentsWithId = '/company-admin/:companyid/appointments',
  companyAdminAppointmentsDetails = '/company-admin/:companyid/appointments/:appointmentid/details',
}

export enum MJGAdminRoutes {
  mjgAdminBase = '/mjg-admin',
  // companies
  mjgAdminCompaniesBase = '/mjg-admin/companies',
  mjgAdminCompanies = '/mjg-admin/companies/:companyid',
  mjgAdminCompaniesShow = '/mjg-admin/companies/:companyid/show',
  mjgAdminCompaniesDashboard = '/mjg-admin/companies/:companyid/dashboard',
  mjgAdminCompaniesArchived = '/mjg-admin/companies/:companyid/archived',
  mjgAdminCompaniesAddEmployee = '/mjg-admin/companies/:companyid/ambassadors/add',
  mjgAdminCompaniesConfiguration = '/mjg-admin/companies/:companyid/configuration',
  mjgAdminCompaniesShowEmployee = '/mjg-admin/companies/:companyid/ambassadors/:employeeid',
  mjgAdminCompaniesEditEmployee = '/mjg-admin/companies/:companyid/ambassadors/:employeeid/edit',
  mjgAdminCompaniesEditEmployeeAvatar = '/mjg-admin/companies/:companyid/ambassadors/:employeeid/edit/avatar',
  mjgAdminCompaniesEditDescription = '/mjg-admin/companies/:companyid/description/edit',
  mjgAdminCompaniesAppointmentsWithId = '/mjg-admin/companies/:companyid/appointments',
  mjgAdminCompaniesAppointmentsDetails = '/mjg-admin/companies/:companyid/appointments/:appointmentid/details',
  // FDR Configuration
  mjgAdminFdrConfiguration = '/mjg-admin/fdr/configuration',
  mjgAdminFdrConfigurationSuccess = '/mjg-admin/fdr/configuration/success',
}

export enum SchoolAssignmentsRoutes {
  schoolAssignmentsBase = '/school/assignments',
  schoolAssignmentsDashboard = '/school/assignments/dashboard',
  schoolAssignmentsDashboardView = '/school/assignments/dashboard/:id',
  schoolAssignmentsDashboardViewEdit = '/school/assignments/dashboard/:id/edit',
  schoolAssignmentsConfiguration = '/school/assignments/configuration',
  schoolAssignmentsConfigurationSuccess = '/school/assignments/configuration/success',
}

enum DefaultRoutes {
  // Signin
  signinView = '/signin',
  signupView = '/:flow/signup',

  // Password
  forgottenPassword = '/forgotten-password',
  forgottenPasswordTokenSent = '/forgotten-password-token-sent',
  changePassword = '/change-password',

  // Search
  search = '/search',

  // Professional
  professional = '/professionals/:id',
  oneDayWithACeo = '/one-day-with-chef-etat-major-marine',
  conversationCreation = '/professionals/:id/conversation/new',
  studentWishlist = '/student/wishlist',

  // Messaging
  conversations = '/conversations',
  conversation = '/conversations/:id',
  conversationReportInterlocutor = '/conversations/:id/report',
  bookAppointment = '/conversations/:id/appointments/create',
  claimAppointment = '/conversations/:id/appointments/claim',
  updateAppointment = '/conversations/:id/appointments/:appointment_id/update',
  deleteAppointment = '/conversations/:id/appointments/:appointment_id/delete',
  downloadConversationAppointmentIcalendar = '/conversations/:id/appointments/:appointment_id/download',
  appointments = '/appointments',
  pastAppointments = '/appointments#past',

  // Review
  reviewView = '/review',

  // Personal Space
  profile = '/profile',
  profileAvatarEdit = '/profile/avatar/edit',
  account = '/account',
  settings = '/settings',
  settingsHibernation = '/settings/hibernation',
  settingsSoftDeletion = '/settings/optout',
  dashboard = '/dashboard',

  // Special Registrations
  ambassadorRegistrationEmailLink = '/registrations/company/employees/new',
  ambassadorRegistrationEmailLinkWithLinkedin = '/users/auth/linkedin',
  resendConfirmationEmail = '/users/confirmation/new?user%5Bemail%5D=:email',

  redCarpets = '/red-carpets',

  // moderation
  standbyMentorModerationsList = '/moderator/mentor_moderations/standby',
  mentorModerationView = '/moderator/mentor_moderations/:id',
  mentorModerationViewStandby = '/moderator/mentor_moderations/:id/standby',
  mentorModerationViewReject = '/moderator/mentor_moderations/:id/reject',
  pendingMentorModerationsList = '/moderator/mentor_moderations',
  moderatorDashboard = '/moderator',

  // moderation ecole
  schoolModerationList = '/moderator/school_moderation',
  schoolModerationView = '/moderator/school_moderation/:id',

  // fdr routes
  assignments = '/assignments',

  // old website
  oldObservatoryOfInitialEmployment = 'https://www.myjobglasses.com/observatoire-du-premier-emploi/articles/ipsos-janvier-2020/',
  mjgAdminOnChronos = '/mjg_admin',

  // softDeletion
  softDeletionGoodbye = '/😭',
  accountRestrictedPage = '/⛔️',

  // Static
  home = '/',
}

const Routes = {
  ...DefaultRoutes,
  ...CompanyAdminRoutes,
  ...MJGAdminRoutes,
  ...SchoolAssignmentsRoutes,
};
type Routes = DefaultRoutes | CompanyAdminRoutes | MJGAdminRoutes | SchoolAssignmentsRoutes;
export default Routes;
